// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-table[data-v-0e9f5b4f] .q-table__card{-webkit-box-shadow:none;box-shadow:none}.container-table[data-v-0e9f5b4f] .q-card__section--vert{padding:0!important}.container-table[data-v-0e9f5b4f] .titleCardEdicion{margin:10px 282px 0 15px;font-family:DINPro;font-weight:500;font-size:20px;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:.29px;color:#474848}", ""]);
// Exports
module.exports = exports;
